import React, { Component } from "react";
import { Accessor, ColorX } from "IZOX/STATIC";
import { HStack, XDiv } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import _ from "lodash";

/**
 * @augments {Component<Props, State>}
 */
class StepDot extends Component {

  static propTypes = {
    curStep: PropsType.number,
    maxStep: PropsType.number,
    inactiveColor: PropsType.string,
    activeColor: PropsType.string,
    size: PropsType.number,
    spacing: PropsType.number, 
    style: PropsType.any
  }

  static defaultProps = {
    curStep: 0,
    maxStep: 4,
    inactiveColor: ColorX.CSS("grey"),
    activeColor: ColorX.CSS("blue"),
    size: 8,
    spacing: 8,
    style: {}
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(StepDot.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    let propIdentical = Accessor.IsIdentical(nextProps, this.props, Object.keys(StepDot.defaultProps));
    let stateIdentical = Accessor.IsIdentical(nextState, this.state, null);
    if(propIdentical && stateIdentical){
      return false;
    }
    return true;
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  render(){
    let {spacing, size, curStep, maxStep, activeColor, inactiveColor, style} = this.props;
    return (
      <HStack spacing={spacing} style={style} width={"auto"} height={30} VAlign="-">
        {_.map(_.range(0, maxStep), (o, i) => {
          return (
            <XDiv key={i} width={size} height={size} round={50} display="block"
              bgColor={i === curStep? activeColor : inactiveColor}/>
          );
        })}
      </HStack>
    );
  }

}

export default StepDot;
